import { parseVideoEmbedUrl } from './video-embed.js';

/** Canonical URL for dedupe, preview exclusion, and mapper text cleanup. */
export function normalizeMediaUrl(url: string): string {
  const trimmed = url.trim();
  const embed = parseVideoEmbedUrl(trimmed);
  if (embed) return embed.watchUrl;

  try {
    const parsed = new URL(trimmed);
    parsed.hash = '';
    return parsed.href.replace(/\/$/, '');
  } catch {
    return trimmed;
  }
}

export function areEquivalentMediaUrls(a: string, b: string): boolean {
  return normalizeMediaUrl(a) === normalizeMediaUrl(b);
}
